<style lang="less" scoped>
.my-toast{
  position: fixed;
  z-index: 3;
  top: 0;
  width: 100vw;
  bottom: 0;
  display:flex;
  justify-content:center;
  align-items: center;
  .success-toast{
    background: rgba(0,0,0,0.7);
    border-radius: 4px;
    padding: 15px 23px;
    div{
      font-size: 13px;
      color: #fff;
    }
    img{
      width: 10vw;
      margin: 0 auto 10px;
      display: block;
    }
  }
}
</style>

<template>
  <div class="my-toast" v-if="showSuccess">
    <div class="success-toast" >
      <img src="../../image/global/toast-success.png" alt="">
      <div>{{msg}}</div>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'

export default {
  data() {
    return {
      showSuccess: false,
      msg: '',
    }
  },
  methods: {
    toast(options) {
      if (options instanceof Error) {
        console.error(options)
      }

      if (!options.type) {
        Toast(options)
      } else {
        this.msg = options.message
        switch (options.type) {
          case 'SUCCESS':
            this.successToast()
            break;
          default:
            break;
        }
      }
    },
    successToast() {
      this.showSuccess = true
      setTimeout(() => {
        this.showSuccess = false
      }, 3000);
    }
  },
}
</script>
